/*
 * hero-banner-full.js
 * - Slideshow (fade) con autoplay + flechas + puntos cuando hay 2+ imágenes.
 * - Parallax + zoom al scroll cuando hay UNA sola imagen en modo "alto".
 * Respeta prefers-reduced-motion.
 */
if (!customElements.get('hero-slideshow')) {
  customElements.define(
    'hero-slideshow',
    class HeroSlideshow extends HTMLElement {
      connectedCallback() {
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.slides = Array.from(this.querySelectorAll('.hero-banner-full__slide'));
        this.dots = Array.from(this.querySelectorAll('.hero-banner-full__dot'));
        this.index = 0;

        // Ocultar el indicador de scroll al bajar (todas las variantes)
        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });

        if (this.slides.length > 1) {
          this.initSlideshow();
        } else {
          this.initParallax();
        }
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        this.stop();
      }

      /* ---------- Slideshow ---------- */
      initSlideshow() {
        const prev = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', () => this.go(this.index - 1, true));
        if (next) next.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true)));

        this.autoplay = this.dataset.autoplay === 'true';
        this.speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;

        // Pausa al pasar el cursor o enfocar
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());

        this.start();
      }

      go(i, manual) {
        const n = this.slides.length;
        this.index = ((i % n) + n) % n;
        this.slides.forEach((s, idx) => {
          const active = idx === this.index;
          s.classList.toggle('is-active', active);
          s.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        this.dots.forEach((d, idx) => d.classList.toggle('is-active', idx === this.index));
        if (manual) this.restart();
      }

      start() {
        if (!this.autoplay || this.reduce || this.slides.length < 2) return;
        this.stop();
        this.timer = setInterval(() => this.go(this.index + 1), this.speed);
      }

      stop() {
        if (this.timer) clearInterval(this.timer);
      }

      restart() {
        this.stop();
        this.start();
      }

      /* ---------- Parallax (una sola imagen) ---------- */
      initParallax() {
        if (!this.classList.contains('hero-banner-full--fill')) return;
        this.img = this.querySelector('.hero-banner-full__img');
        this.media = this.querySelector('.hero-banner-full__media');
        if (!this.img || !this.media || this.reduce) return;
        this.parallax = true;
        this.updateParallax();
      }

      updateParallax() {
        const rect = this.media.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const progress = Math.min(Math.max((vh - rect.top) / (vh + rect.height), 0), 1);
        const shift = (progress - 0.5) * 60;
        const scale = 1.04 + progress * 0.06;
        this.img.style.transform = `translate3d(0, ${shift.toFixed(1)}px, 0) scale(${scale.toFixed(3)})`;
      }

      onScroll() {
        const rect = this.getBoundingClientRect();
        this.classList.toggle('is-scrolled', rect.top < -40);
        if (this.parallax) {
          if (!this.ticking) {
            window.requestAnimationFrame(() => {
              this.updateParallax();
              this.ticking = false;
            });
            this.ticking = true;
          }
        }
      }
    }
  );
}
